module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-title', {
    staticClass: "overline grey lighten-4 py-1"
  }, [_vm._v("Choose a practitioner:")]), _vm._v(" "), _vm._l((_vm.getColleagues), function(practitioner) {
    return [(practitioner.is_active) ? _c('v-chip', {
      key: practitioner.id,
      class: {
        'info white--text': _vm.idsAreEqual(practitioner.id, _vm.practitionerId)
      },
      on: {
        "click": function($event) {
          _vm.local.practitioner = practitioner
        }
      }
    }, [(_vm.idsAreEqual(practitioner.id, _vm.practitionerId)) ? _c('v-icon', {
      attrs: {
        "left": ""
      }
    }, [_vm._v("check")]) : _vm._e(), _vm._v("\n        " + _vm._s(practitioner.full_name) + "\n      ")], 1) : _vm._e()]
  })], 2), _vm._v(" "), (_vm.practitionerId) ? _c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-title', {
    staticClass: "overline grey lighten-4 py-1"
  }, [_vm._v("Choose a space:")]), _vm._v(" "), _vm._l((_vm.local.practitioner.memberships), function(mem) {
    return [(mem.is_active) ? _c('v-chip', {
      key: mem.id,
      class: {
        'info white--text': _vm.idsAreEqual(mem.service, _vm.spaceId)
      },
      on: {
        "click": function($event) {
          _vm.local.space = mem.service_data
        }
      }
    }, [(_vm.idsAreEqual(mem.service, _vm.spaceId)) ? _c('v-icon', {
      attrs: {
        "left": ""
      }
    }, [_vm._v("check")]) : _vm._e(), _vm._v("\n        " + _vm._s(mem.space_name) + "\n      ")], 1) : _vm._e()]
  })], 2) : _vm._e(), _vm._v(" "), (_vm.practitionerId && _vm.spaceId) ? _c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-title', {
    staticClass: "overline grey lighten-4 py-1"
  }, [_vm._v("Choose an appointment type:")]), _vm._v(" "), _vm._l((_vm.products), function(product) {
    return [_c('v-chip', {
      key: product.id,
      class: {
        'info white--text': _vm.idsAreEqual(_vm.local.product.id, product.id)
      },
      on: {
        "click": function($event) {
          _vm.local.product = product
        }
      }
    }, [(_vm.idsAreEqual(_vm.local.product.id, product.id)) ? _c('v-icon', {
      attrs: {
        "left": ""
      }
    }, [_vm._v("check")]) : _vm._e(), _vm._v("\n        " + _vm._s(product.title) + "\n      ")], 1)]
  })], 2) : _vm._e(), _vm._v(" "), (_vm.productId && _vm.local.product.locations && _vm.local.product.locations.length > 0) ? _c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-title', {
    staticClass: "overline grey lighten-4 py-1"
  }, [_vm._v("Choose a location:")]), _vm._v(" "), _vm._l((_vm.local.product.locations), function(location) {
    return [_c('v-chip', {
      key: ((location.id) + "-" + _vm.productId),
      class: {
        'info white--text': _vm.idsAreEqual(location.id, _vm.local.location.id)
      },
      on: {
        "click": function($event) {
          _vm.local.location = location
        }
      }
    }, [(_vm.idsAreEqual(location.id, _vm.local.location.id)) ? _c('v-icon', {
      attrs: {
        "left": ""
      }
    }, [_vm._v("check")]) : _vm._e(), _vm._v("\n        " + _vm._s(location.name) + "\n      ")], 1)]
  })], 2) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6ebfd34a","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pickers/PractitionerProductPicker.vue
// module id = 1462
// module chunks = 9